export class DialogBuilderExceptionConstant {

  //#region Properties

  public static readonly invalidDialogSettings = 'INVALID_DIALOG_SETTINGS';

  //#endregion
}
